export default __webpack_public_path__ + "static/media/eb-ultra-wht-3.0fbc4a6f.png";